<template>
  <div class="subscription-overview-view">
    <SubscriptionOverview />
  </div>
</template>

<script>
import SubscriptionOverview from '@/components/SubscriptionOverview.vue'
import helper from '../helper'
export default {
  name: 'SubscriptionOverviewView',
  components: {
    SubscriptionOverview
  },
  mounted(){
    window.mixpanel.track("subscription_overview");
        //check permissions
    if(helper.checkAccess('view_subscriptions') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_subscriptions') == -2) return this.$router.push({path : '/subscribe'})

  }
}
</script>

<style scoped>
.subscription-overview-view {
  padding: 1rem;
}
</style> 